import WorkflowList from './WorkflowList'
import WorkflowCreate from './WorkflowCreate'
import WorkflowShow from './WorkflowShow'
import WorkflowEdit from './WorkflowEdit'
import AccountTreeIcon from '@mui/icons-material/AccountTree'

export default {
  list: WorkflowList,
  create: WorkflowCreate,
  show: WorkflowShow,
  edit: WorkflowEdit,
  icon: AccountTreeIcon,
}
